import { classNames, h } from "omi";

import { QuestionStatus } from "../../models";
import { getShortcut } from "../../utils.ts";

export function AnswerTile({
  key,
  text,
  selected,
  onClick,
  status,
}: {
  key: number;
  text: string;
  selected: boolean;
  onClick: () => void;
  status: QuestionStatus | undefined;
}) {
  return (
    <button
      className={classNames(
        "relative flex items-center gap-6 p-6 border border-primary rounded-2xl transition-all duration-150 ease-in-out focus:outline-none focus:shadow-ring-sxs",
        {
          "!bg-success-100 !border-success-300 ring-2 ring-success-300 ring-offset-2":
            status === QuestionStatus.Correct,
          "!bg-error-100 !border-error-300 ring-2 ring-error-300 ring-offset-2": status === QuestionStatus.Incorrect,
          "shadow-ring-sxs bg-primary-hover": selected && (status == null || status == QuestionStatus.NotStarted),
          "hover:bg-primary-hover": status == null || status == QuestionStatus.NotStarted,
        },
      )}
      onClick={onClick}
    >
      <div className="px-2.5 py-1 border border-primary bg-white rounded-lg text-secondary flex items-center justify-center">
        {getShortcut(key)}
      </div>
      <p className="text-secondary">{text}</p>
    </button>
  );
}
